<template>
	<div class="best-price-selection">
		<button
			v-if="filter"
			type="button"
			class="best-price-selection__filter-button"
			@click="deleteFilter"
		>
			<div class="best-price-selection__filter-button-left">
				<BaseIcon
					v-if="offerType === 'package'"
					name="planeGo"
					class="best-price-selection__plane-icon"
				/>
				<div class="best-price-selection__filter-button--text">
					<span>Hinreise am </span><strong>{{ getFilterBtnLabel() }}</strong>
				</div>
			</div>
			<BaseIcon
				name="cancel"
				class="best-price-selection__cancel-icon"
			/>
		</button>
	</div>
</template>

<script lang="ts" setup>
import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import { formatDate } from '@/js/utils/dateTimeUtils';
import { computed } from 'vue';
import { useStore } from '@/components/common/store';

const store = useStore();

const props = withDefaults(
	defineProps<{
		filter?: string | null;
	}>(),
	{
		filter: '',
	}
);

const emit = defineEmits(['deleteFilter']);

const formData = computed(() => store.state.searchMask);

const offerType = computed((): 'package' | 'hotel' => (formData.value.onlyHotel ? 'hotel' : 'package'));

const getFilterBtnLabel = (): string => {
	if (!props.filter) {
		return '';
	}

	const weekday = formatDate(props.filter, { weekday: 'long' });
	const formatted = formatDate(props.filter, { year: 'numeric', month: '2-digit', day: '2-digit' });
	return `${weekday}, ${formatted}`;
};

const deleteFilter = () => {
	emit('deleteFilter');
};
</script>

<style lang="scss" scoped>
.best-price-selection {
	&__filter-button {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		margin: 0 auto 1.5rem;
		padding: 0.5rem 1.5rem;
		border: 0.1rem solid $color-secondary;
		border-radius: $border-radius-large;
		background: none;
		color: $color-primary;
		font-size: $font-small-2;
		font-weight: $font-weight-semibold;

		&--text {
			margin-top: -0.2rem;
		}

		strong {
			font-weight: $font-weight-bold;
		}

		span,
		strong {
			vertical-align: middle;
		}
	}

	&__cancel-icon {
		margin-right: 0.5rem;
		margin-left: 0.2rem;
		fill: $color-primary;
		width: 1rem;
		height: 1rem;
	}

	&__plane-icon {
		fill: $color-primary;
		width: 2.3rem;
		height: 2.3rem;
	}

	&__filter-button-left {
		display: flex;
		align-items: center;
		gap: 1.5rem;
	}

	@include media-query-up($breakpoint-large) {
		&__filter-button {
			margin-left: 0;
			font-size: $font-medium-3;
		}

		&__plane-icon {
			width: 2.6rem;
			height: 2.6rem;
		}

		&__cancel-icon {
			width: 1.8rem;
			height: 1.8rem;
		}
	}
}
</style>
